<template>
  <article>
    <section class="xbed-sub-title">
      <span>前台下单</span>
    </section>

    <section class="add-distance">
      <Form :model="frontOrderForm" ref="frontOrderForm" :rules="ruleValidate">
        <Row>
          <Col span="7">
            <FormItem prop="rentType" label="租房类型：" :label-width="120" style="margin-right: 40px">
              <Input type="text" value="短租" disabled></Input>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem label="订单来源：" prop="sourceType" :label-width="120" style="margin-right: 40px">
              <Select v-model="frontOrderForm.sourceType" @on-change="changeSourceType" filterable>
                <Option v-for="source in sourceType" :key="source.id" :value="source.id">{{source.name}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem label="OTA单号：" prop="otherNo" :label-width="120" style="margin-right: 40px">
              <Input type="text" v-model="frontOrderForm.otherNo"></Input>
            </FormItem>
          </Col>
        </Row>
        <!-- <Row>
          <Col span="7" offset="2">
            <FormItem label="渠道单号/合作商" prop="otherNo" :label-width="140">
              <Input type="text" v-model="frontOrderForm.otherNo"></Input>
            </FormItem>
          </Col>
        </Row> -->
        <Row>
          <Col span="7">
            <FormItem prop="phone" label="预订人手机：" :label-width="120" style="margin-right: 40px">
              <Input type="text" v-model.trim="frontOrderForm.phone" :maxlength="11"></Input>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem prop="name" label="入住人姓名 (逗号隔开)" class="check-name" :label-width="120" style="margin-right: 40px">
              <Input type="text" v-model="frontOrderForm.name"></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="7">
            <FormItem  label="入离时间：" prop="checkDate" :label-width="120" style="margin-right: 40px">
              <DatePicker v-model="frontOrderForm.checkDate" @on-change="dateRange => {changeDate(dateRange, 'frontOrderForm', 'checkDate')}" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 100%" :options="dateOptions" :clearable="false" :editable="false"></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="18">
            <FormItem label="房间：" :label-width="120">
              <Table stripe :columns="selectedRoomsColumn" :data="selectedRooms"></Table>
            </FormItem>
          </Col>
          <Col span="2" style="margin-left: 5.1%;">
            <FormItem>
              <Button type="primary" @click="openSelectingRoomsModal">选择房间</Button>
            </FormItem>
            <FormItem>
              <Button @click="clearRooms">清空房间</Button>
            </FormItem>
          </Col>
        </Row>
        <Row v-if="currentSourceData.priceRelationState" class="showOta">
          <!-- <Button type="primary">获取OTA订单数据</Button> -->
          <a class="ivu-btn" @mouseenter="showChannel = true" @mouseleave="showChannel = false" :style="{'position': 'absolute','right': '57px','z-index':showChannel ? '1001' : 1}">*渠道金额对应关系</a>
        </Row>
        <Row>
          <Col span="7">
            <FormItem label="xbed原价：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" :value="frontOrderForm.totalPrice" disabled>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem prop="discount" label="总优惠：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="frontOrderForm.discount" @input="calculateIn('discount')" :disabled="priceExpression.discount.type === 1" ref='discount'>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="7">
            <FormItem prop="salePrice" label="渠道售价：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="frontOrderForm.salePrice" @input="calculateIn('salePrice')" :disabled="priceExpression.salePrice.type === 1" ref='salePrice'>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem prop="channelDiscount" label="渠道优惠：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="frontOrderForm.channelDiscount" @input="calculateIn('channelDiscount')" :disabled="priceExpression.channelDiscount.type === 1" ref='channelDiscount'>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem prop="discountType" key="discountType" label="优惠类型：" :label-width="120" style="margin-right: 40px">
              <Select v-model="frontOrderForm.discountType" placeholder="请选择优惠类型" :disabled="frontOrderForm.discount === 0">
                <Option v-for="discount in discountType" :key="discount.id" :value="discount.id">{{discount.name}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="7">
            <FormItem prop="realPrice" label="客人应付：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="frontOrderForm.realPrice" @input="calculateIn('realPrice')" :disabled="priceExpression.realPrice.type === 1" ref='realPrice'>
            </FormItem>
          </Col>
          <!-- <Col span="7">
            <FormItem prop="userPay" label="客人实付：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="frontOrderForm.userPay" @input="calculateIn('userPay')" :disabled="priceExpression.userPay.type === 1" ref='userPay'>
            </FormItem>
          </Col> -->
          <Col span="7">
            <FormItem prop="channelCommission" key="channelCommission" label="OTA佣金：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="frontOrderForm.channelCommission" @input="calculateIn('channelCommission')" :disabled="priceExpression.channelCommission.type === 1" ref='channelCommission'>
            </FormItem>
          </Col>
          <Col span="7">
            <FormItem prop="invoicePrice" label="发票金额：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="frontOrderForm.invoicePrice"  @input="calculateIn('invoicePrice')" :disabled="priceExpression.invoicePrice.type === 1" ref='invoicePrice'>
            </FormItem>
          </Col>
        </Row>
        <!-- <Row>
          <Col span="7">
            <FormItem prop="otherChannelExpenses" label="渠道活动费：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="frontOrderForm.otherChannelExpenses" @input="calculateIn('otherChannelExpenses')" :disabled="priceExpression.otherChannelExpenses.type === 1" ref='otherChannelExpenses'>
            </FormItem>
          </Col>
        </Row> -->
        <Row>
          <Col span="7">
            <FormItem prop="receivedPrice" label="xbed实收：" :label-width="120" style="margin-right: 40px">
              <input class="inputType" type="number" v-model.number="frontOrderForm.receivedPrice" @input="calculateIn('receivedPrice')" :disabled="priceExpression.receivedPrice.type === 1" ref='receivedPrice'>
            </FormItem>
          </Col>
          <Col span="7" v-if="currentSourceData.invoceConfig === 2" style="margin-left: 452px">
            <FormItem label="" :label-width="120">
              <Checkbox v-model="frontOrderForm.invoicing">客人向xbed申请开发票</Checkbox>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col style="width: 85%;">
            <FormItem prop="remark" label="备注：" :label-width="120">
              <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="frontOrderForm.remark" placeholder="必填"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </section>
    <section>
      <Button type="primary" @click="placeOrder" :loading="btnLoading" size="large" style="width: 180px;margin-left:120px;">提交</Button>
    </section>

    <Modal v-model="selectingRoomsModalDisplay" ref="selectingRoomsModal" title="选择房间" ok-text="选好了" :width="950" @on-ok="selectingRooms" @on-cancel="cancelSelectedRooms">
      <Form :model="selectingRoomsModalForm">
        <Row>
          <Col span="8">
            <FormItem prop="phone" label="门店：" :label-width="80">
              <Select v-model="selectingRoomsModalForm.hotel" transfer clearable filterable>
                <Option v-for="hotel in allHotels" :key="hotel.sourceId" :value="hotel.sourceId">{{hotel.sourceName}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8" offset="1">
            <FormItem prop="name" label="房型：" :label-width="80">
              <Select v-model="selectingRoomsModalForm.roomType" transfer clearable filterable>
                <Option v-for="roomType in allRoomTypes" :key="roomType.code" :value="roomType.cname">{{roomType.cname}}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem prop="roomNo" label="房号：" :label-width="80">
              <Input type="text" v-model="selectingRoomsModalForm.roomNo"></Input>
            </FormItem>
          </Col>
          <Col span="8" offset="1">
            <FormItem prop="roomName" label="房名：" :label-width="80">
              <Input type="text" v-model="selectingRoomsModalForm.roomName"></Input>
            </FormItem>
          </Col>
          <Col span="6" offset="1">
            <FormItem>
              <Button type="primary" @click="queryRoomListWithKeyword">查找</Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table stripe ref="modalSelection" :loading="roomList.loading" height="450" :columns="roomListColumn" :data="roomList.data"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="roomList.count" :current="roomList.page" :page-size="roomList.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
      </div>
      <Row>
        <Col>{{`已选择${modalSelectedRooms.length}房`}}</Col>
      </Row>
    </Modal>
    <!-- 渠道金额对应关系弹窗 -->
    <Modal v-model="showChannel" title="渠道金额对应关系" footer-hide :closable="false" class="channel-modal" :styles="{width: '600px', top: '250px'}">
      <Row class="channel-row">
        <Col span="11" class="col"><em class="txt">渠道售价 = </em><span :class="priceRelationDetail.salePrice ? '' : 'red'">{{priceRelationDetail.salePrice || channelText}}</span></Col>
        <Col span="11" class="col"><em class="txt">渠道优惠 = </em><span :class="priceRelationDetail.channelDiscount ? '' : 'red'">{{priceRelationDetail.channelDiscount || channelText}}</span></Col>
      </Row>
      <Row class="channel-row">
        <Col span="11" class="col"><em class="txt">OTA佣金 = </em><span :class="priceRelationDetail.channelCommission ? '' : 'red'">{{priceRelationDetail.channelCommission || channelText}}</span></Col>
        <Col span="11" class="col"><em class="txt">发票金额 = </em><span :class="priceRelationDetail.invoicePrice ? '' : 'red'">{{priceRelationDetail.invoicePrice || channelText}}</span></Col>
      </Row>
      <Row class="channel-row">
        <Col span="11" class="col"><em class="txt" style="min-width:112px;">客人应付 = </em><span :class="priceRelationDetail.userRealPay ? '' : 'red'">{{priceRelationDetail.userRealPay || channelText}}</span></Col>
        <Col span="11" class="col"><em class="txt" style="min-width:85px;">xbed实收 = </em><span :class="priceRelationDetail.receivedPrice ? '' : 'red'">{{priceRelationDetail.receivedPrice || channelText}}</span></Col>
      </Row>
    </Modal>
  </article>
</template>

<script>
/* eslint-disable */
import Moment from "moment"
import Utils from "../../utils";
import API from "../../api";
import {phoneRegular} from "../../utils/regular"

export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.userid = Utils.findFromLocalStorage("vue-userid");
    this.env = Utils.findFromLocalStorage("env", "dev");

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'group': 'dev' // 本地请求才需要加该参数
    }
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    this.hotspotPowerIds = (await API.omsAPI[this.env].php.getHotSpotIds()).data.toString();
    let orderSourceResp = (await API.omsAPI[this.env].php.queryOrderSource()).data;
    let discountType = (await API.omsAPI[this.env].order.getDiscountType(2, this.token)).data;
    this.discountType = this.discountType.concat(discountType);
    this.sourceType = orderSourceResp.retdata.filter(source => {
      if (source.sourceType==4 && source.status==1 && source.isShow ==1) {
        return true;
      }
    });
    this.changeSourceType(23)
  },
  data() {
    let defaultDate = [
      Moment().format("YYYY-MM-DD"),
      Moment().add(1, 'days').format("YYYY-MM-DD"),
    ];
    // const realPriceValidate = {
    //   realPrice: ( rule, value, callback ) => {
		// 		if (this.frontOrderForm.realPrice < (this.frontOrderForm.totalPrice * 0.6.toFixed(2))) {
		// 			callback( new Error( `应付金额不可低于Xbed订单总价的60%，即${(this.frontOrderForm.totalPrice * 0.6).toFixed(2)}元` ) )
		// 		} else {
		// 			callback();
		// 		}
		// 	},
    // }

    const validatePrice = {
      discount: (rule, value, callback) => {
        if (isNaN(parseFloat(this.frontOrderForm.discount)) && this.priceExpression.discount.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      invoicePrice: (rule, value, callback) => {
        if (isNaN(parseFloat(this.frontOrderForm.invoicePrice)) && this.priceExpression.invoicePrice.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      channelCommission: (rule, value, callback) => {
        if (isNaN(parseFloat(this.frontOrderForm.channelCommission)) && this.priceExpression.channelCommission.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      realPrice: (rule, value, callback) => {
        if (isNaN(parseFloat(this.frontOrderForm.realPrice)) && this.priceExpression.realPrice.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      // otherChannelExpenses: (rule, value, callback) => {
      //   if (isNaN(parseFloat(this.frontOrderForm.otherChannelExpenses)) && this.priceExpression.otherChannelExpenses.type === 2) {
      //     callback(new Error('请输入金额'));
      //   } else {
      //     callback();
      //   }
      // },
      // userPay: (rule, value, callback) => {
      //   if (isNaN(parseFloat(this.frontOrderForm.userPay)) && this.priceExpression.userPay.type === 2) {
      //     callback(new Error('请输入金额'));
      //   } else {
      //     callback();
      //   }
      // },
      receivedPrice: (rule, value, callback) => {
        if (isNaN(parseFloat(this.frontOrderForm.receivedPrice)) && this.priceExpression.receivedPrice.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      salePrice: (rule, value, callback) => {
        if (isNaN(parseFloat(this.frontOrderForm.salePrice)) && this.priceExpression.salePrice.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      channelDiscount: (rule, value, callback) => {
        if (isNaN(parseFloat(this.frontOrderForm.channelDiscount)) && this.priceExpression.channelDiscount.type === 2) {
          callback(new Error('请输入金额'));
        } else {
          callback();
        }
      },
      otherNo: (rule, value, callback) => {
        let strRegular = /^[a-zA-Z0-9+`~!@#$^*()-\\./?,<>;:'{}|]+$/
        if (this.frontOrderForm.otherNo.trim()=="") {
          callback(new Error('OTA单号不能为空'));
        } if (!strRegular.test(this.frontOrderForm.otherNo)) {
          callback(new Error('存在空格和不支持的符号，请修改'));
        } else {
          callback();
        }
      },
    }

    const validateDiscountType = (rule, value, callback) => {
      if (!this.frontOrderForm.discountType && this.frontOrderForm.discount !== 0) {
        callback(new Error('请选择优惠类型'))
      } else {
        callback();
      }
    }

    return {
      showChannel: false,   // 是否显示 渠道金额对应关系 弹窗
      priceRelationDetail: {}, // 渠道金额对应关系
      currentSourceData: {},  // 当前选择的订单来源相关数据
      channelText: '系统自动计算',
      priceExpression: { // 订单来源的金额信息
        salePrice: {},
        channelDiscount: {},
        discount: {},
        realPrice: {},
        // userPay: {},
        channelCommission: {},
        // otherChannelExpenses: {},
        receivedPrice: {},
        invoicePrice: {}
      },
      delayTimer: null,
      sourceType: [],
      allHotels: [],
      allRoomTypes: [],
      dateOptions: {
        disabledDate (date) {
          let today = Moment().startOf('day').valueOf();
          let nowTime = Moment().valueOf();
          let oneDay = 86400000;
          if (nowTime < today+21600000) {
            return date &&  date.valueOf() < (Date.now() - (oneDay * 2))
          } else {
            return date && date.valueOf() < Date.now() - oneDay;
          }
        }
      },
      frontOrderForm: {
        sourceType: 23,
        phone: "",
        name: "",
        checkDate: defaultDate,
        rooms: "",
        invoicing: false,
        invoicePrice: "",
        totalPrice: '',
        discount: '',
        realPrice: '',
        remark: "",
        otherNo:'',
        discountType: 0,
        salePrice: '',
        channelDiscount: '',
        // userPay: 0,
        // otherChannelExpenses: '',
        channelCommission: '',
        receivedPrice: ''
      },
      discountType:[
         {
           id:0,
           isShow:1,
           name: '请选择',
           type: 2
         }
      ],
      selectingRoomsModalDisplay: false,
      selectingRoomsModalForm: {
        hotel: "",
        roomType: "",
        roomNo: "",
        roomName: ""
      },
      selectedRoomsColumn: [
        {
          title: "房型",
          key: "roomType",
          align: "center",
          width: 190
        },
        {
          title: "房号",
          key: "roomNo",
          align: "center",
          width: 257
        },
        {
          title: "房名",
          key: "roomName",
          align: "center",
          width: 390
        },
        {
          title: "门店",
          key: "hotel",
          align: "center",
          width: 260
        }
      ],
      selectedRooms: [],
      roomListColumn: [
        {
          title: "操作",
          align: "center",
          width: 100,
          fixed: 'left',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: params.row.isChecked ? "error" : "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.selectedChangeWithRow(params.row);
                    }
                  }
                },
                params.row.isChecked ? "取消选择" : "选择"
              )
            ]);
          }
        },
         {
          title: "房号",
          key: "custRoomNo",
          align: "center",
          fixed: 'left',
          width: 100
        },
        {
          title: "价格（元）",
          key: "price",
          align: "center",
          fixed: 'left',
          width: 200,
          render: (h, params) => {
            let price = (params.row.price / 100).toFixed(2);
            return h("div", {}, price);
          }
        },
        {
          title: "当前状态",
          key: "stat",
          align: "center",
          width: 150,
          render: (h, params) => {
            let stat = "";
            switch(params.row.stat) {
              case 1:
                stat = "干净房"
                break;
              case 2:
                stat = "脏房"
                break;
              case 3:
                stat = "已入住"
                break;
              case 4:
                stat = "停用"
                break;
              case 5:
                stat = "维修"
                break;
            }
            return h("div", {}, stat);
          }
        },
        {
          title: "房间展示名",
          key: "custRoomName",
          align: "center",
          width: 200
        },
        {
          title: "房型",
          key: "roomTypeName",
          align: "center",
          width: 150
        },
        {
          title: "所属门店",
          key: "chainName",
          align: "center",
          width: 200
        },
        {
          title: "所属楼宇",
          key: "buildingName",
          align: "center",
          width: 200
        },
        
      ],
      roomList: {
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      },
      modalSelectedRooms: [],
      modalSelectedRoomsPrice: {
        orderPrice: 0,
        realPrice: 0
      },
      btnLoading: false,
      ruleValidate: {
        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          { type: "string", pattern: phoneRegular, message: "请填写正确的手机号码" }
        ],
        name: [
          { required: true, message: "姓名不能为空", trigger: "blur" }
        ],
        otherNo:[
           { type: "string", max: 50, message: "字符长度不能超过50" },
           { validator: validatePrice.otherNo, trigger: 'blur' }
        ],
        discountType: [
          { validator: validateDiscountType, trigger: "change" }
        ],
        discount: [
          { validator: validatePrice.discount, type: "number", trigger: 'blur' }
        ],
        salePrice: [
          { validator: validatePrice.salePrice, type: "number", trigger: 'blur' }
        ],
        channelDiscount: [
          { validator: validatePrice.channelDiscount, type: "number", trigger: 'blur' }
        ],
        invoicePrice: [
          { validator: validatePrice.invoicePrice, type: "number", trigger: 'blur' }
        ],
        channelCommission: [
          { validator: validatePrice.channelCommission, type: "number", trigger: 'blur' }
        ],
        realPrice: [
          { validator: validatePrice.realPrice, type: "number", trigger: 'blur' }
        ],
        // otherChannelExpenses: [
        //   { validator: validatePrice.otherChannelExpenses, type: "number", trigger: 'blur' }
        // ],
        // userPay: [
        //   { validator: validatePrice.userPay, type: "number", trigger: 'blur' }
        // ],
        receivedPrice: [
          { validator: validatePrice.receivedPrice, type: "number", trigger: 'blur' }
        ],
        // realPrice:[
        //   {required: true, validator: realPriceValidate.realPrice, trigger: 'blur'}
        // ],
        remark: [
          { required: true, message: "请填写备注", trigger: "blur" },
          { type: "string", max: 500, message: "备注不能超过500字" }
        ],
      },
    };
  },
  methods: {
    changeDate(dateRange, formName, datePicker) {
      if (!dateRange[0]) {
        this[formName][datePicker] = [];
      } else {
        if (dateRange[0]==dateRange[1]) {
          dateRange[1] = Moment(dateRange[1]).add(1, 'day')
        }
        let tranferDate = [
          Moment(dateRange[0]).format('YYYY-MM-DD'),
          Moment(dateRange[1]).format('YYYY-MM-DD')
        ]
        this[formName][datePicker] = tranferDate;
      }
      this.clearRooms();
    },
    async openSelectingRoomsModal() {
      this.selectingRoomsModalDisplay = true;
      let params = {hotspotPowerIds: this.hotspotPowerIds};
      let selectListResp = (await API.omsAPI[this.env].php.querySelectList(params)).data.data;
      this.allHotels = selectListResp.chain;
      if (this.allHotels.length>0) {
        this.selectingRoomsModalForm.hotel = this.allHotels[0].sourceId;
      }

      let roomTypesResp = (await API.omsAPI[this.env].php.queryModeAndStyleAndType({ operTypeList: ['roomType'] })).data;
      this.allRoomTypes = roomTypesResp.retdata;

      this.modalSelectedRooms = [...this.selectedRooms];
      this.modalSelectedRoomsPrice.orderPrice = this.frontOrderForm.totalPrice * 100;
      this.modalSelectedRoomsPrice.realPrice = this.modalSelectedRoomsPrice.orderPrice ? (this.frontOrderForm.totalPrice * 100) : 0;
    },
    // 查询房间列表
    checkQueryParams() {
      if ( !this.selectingRoomsModalForm.hotel ) {
        this.$Notice.error({
          title: "查询失败",
          desc: "门店不能为空"
        });
        return false;
      }
      return true;
    },
    queryRoomListWithKeyword() {
      if (!this.checkQueryParams()) {
        return;
      }
      this.roomList.page = 1;
      this.queryRoomList()
    },
    async queryRoomList() {
      this.roomList.loading = true;
      let resp = (await this.sendRoomList(this.roomList, this.token, this.env)).data;
      if(resp && resp.roomList){
        this.roomList.data = resp.roomList.map(room => {
          room.isChecked = false;
          return room;
        });
        this.roomList.count = resp.totalElements;
      }
      this.roomList.loading = false;

      this.$nextTick(() => {
        this.changeRowCheckedProps();
      });
    },
    sendRoomList(roomList, token, env) {
      let params = {
        page: roomList.page,
        size: roomList.pageSize,
        beginDate: Moment(this.frontOrderForm.checkDate[0]).format("YYYY-MM-DD"),
        endDate: Moment(this.frontOrderForm.checkDate[1]).format("YYYY-MM-DD"),
        tag: "cnameWay=租赁方式/短租"
      }
      this.selectingRoomsModalForm.hotel? params.chainId = this.selectingRoomsModalForm.hotel : '';
      this.selectingRoomsModalForm.roomType? params.roomTypeName = this.selectingRoomsModalForm.roomType : '';
      this.selectingRoomsModalForm.roomNo? params.custRoomNo = this.selectingRoomsModalForm.roomNo : '';
      this.selectingRoomsModalForm.roomName? params.custRoomName = this.selectingRoomsModalForm.roomName : '';
      return API.omsAPI[env].order.queryAvailableRooms(params, token);
    },
    changeRealPrice(){
      if (this.$refs.realPrice.value.length > 8) {
        this.$refs.realPrice.value = this.$refs.realPrice.value.slice(0, 8)
        this.frontOrderForm.realPrice = this.$refs.realPrice.value
        }
      this.frontOrderForm.discount = Math.round((this.frontOrderForm.totalPrice - this.frontOrderForm.realPrice)*100)/100;
    },
    changeRowCheckedProps() {
      let length = this.modalSelectedRooms.length;
      for (let i = 0; i < length; i++) {
        let roomId = this.modalSelectedRooms[i].roomId;
        for (let j = 0; j < this.roomList.data.length; j++) {
          let matchRoomId = this.roomList.data[j].roomId;
          if (roomId == matchRoomId) {
            this.roomList.data[j].isChecked = true;
          }
        }
      }
    },
    async selectedChangeWithRow(currRow) {
      currRow.isChecked = !currRow.isChecked
      if (currRow.isChecked) {
        let roomId = currRow.roomId
        let params = {
          beginDateTime: Moment(this.frontOrderForm.checkDate[0]).format("YYYY-MM-DD"),
          endDateTime: Moment(this.frontOrderForm.checkDate[1]).format("YYYY-MM-DD"),
          roomId
        }

        let resp = (await API.omsAPI[this.env].order.queryRoomsPrice(params, this.token)).data;
        if (resp.status==false) {
          this.$Notice.error({
            title: "选择失败",
            desc: resp.msg
          });
          currRow.isChecked = !currRow.isChecked
          return;
        }
        
        let room = Object.values(resp)[0];
        let selectedRoom = {
          roomId: currRow.roomId,
          roomType: currRow.roomTypeName,
          roomNo: currRow.custRoomNo,
          roomName: currRow.custRoomName,
          hotel: currRow.chainName,
          price: room.price,
          number: room.number
        };
        this.modalSelectedRooms.push(selectedRoom);
        this.modalSelectedRoomsPrice = {
          orderPrice: this.modalSelectedRoomsPrice.orderPrice + room.price,
          realPrice: this.modalSelectedRoomsPrice.realPrice + room.price
        }
      } else {
        let delIndex = -1;
        for (let i=0; i<this.modalSelectedRooms.length; i++) {
          let matchRoomId = this.modalSelectedRooms[i].roomId;
          if (currRow.roomId == matchRoomId) {
            this.modalSelectedRoomsPrice = {
              orderPrice: this.modalSelectedRoomsPrice.orderPrice - this.modalSelectedRooms[i].price,
              realPrice: this.modalSelectedRoomsPrice.realPrice - this.modalSelectedRooms[i].price
            }
            delIndex = i;
            break;
          }
        }

        this.modalSelectedRooms.splice(delIndex, 1);
      }
    },
    changePage(pageIndex) {
      this.roomList.page = pageIndex;
      this.queryRoomList();
    },
    changePageSize(pageSize) {
      this.roomList.page = 1;
      this.roomList.pageSize = pageSize;
      // this.queryRoomList();
    },
    selectingRooms() {
      this.selectedRooms = this.modalSelectedRooms;
      this.frontOrderForm.totalPrice = this.modalSelectedRoomsPrice.orderPrice / 100;
      this.resetSelectingRoomsModalForm();
      this.resetRoomList();
      if (this.selectedRooms.length > 0) this.calculateIn('default') // 重新计算价格
      this.resetFormFields()
    },
    cancelSelectedRooms() {
      this.modalSelectedRooms = [];
      this.resetSelectingRoomsModalForm();
      this.resetRoomList();
    },
    async placeOrder() {
      let validResult = true;
      this.$refs["frontOrderForm"].validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        return;
      }
      let checkedResult = this.checkPlaceOrderParams();
      if (!checkedResult.result) {
        this.$Notice.error({
          title: "下单失败",
          desc: checkedResult.msg
        });
        return;
      }
      this.btnLoading = true;
      let roomIds = this.getRoomIds();
      let resp = (await this.sendPlaceOrder(this.frontOrderForm,roomIds,
        this.userid
      )).data;
      this.btnLoading = false;
      if (resp.retCode) {
        // 错误警告
        this.$Notice.error({
          title: "下单失败",
          desc: resp.msg
        });
      } else {
        this.$Notice.success({
          title: "下单成功"
        });

        // TODO:下单成功后需清空
        this.clearAllData()

        window.open(`#/Order/Reserve/newOrderDetailView?orderNo=${resp}`);
      }
    },
    sendPlaceOrder(frontOrderForm, roomIds, userId) {
      let params = {
        activityId: -1,
        rentType: 1,
        discount: ((frontOrderForm.discount)*100).toFixed(0),
        
        userId: userId,
        source: frontOrderForm.sourceType,
        beginDate: Moment(frontOrderForm.checkDate[0]).format("YYYY-MM-DD"),
        endDate: Moment(frontOrderForm.checkDate[1]).format("YYYY-MM-DD"),
        otherNo: frontOrderForm.otherNo,
        name: frontOrderForm.name,
        phone: frontOrderForm.phone,
        realPrice: Math.round(frontOrderForm.realPrice*100),
        orderPrice: Math.round(frontOrderForm.totalPrice*100),
        invoicePrice: Math.round(frontOrderForm.invoicePrice * 100),
        remark: frontOrderForm.remark,
        needInvoice: frontOrderForm.invoicing || this.currentSourceData.invoceConfig === 1 ? 1 : 0,
        operator: this.username,
        roomIds,
        salePrice: ((frontOrderForm.salePrice) * 100).toFixed(0),
        channelDiscount: ((frontOrderForm.channelDiscount) * 100).toFixed(0),
        // userPay: 0, // ((frontOrderForm.userPay) * 100).toFixed(0),
        channelCommission: ((frontOrderForm.channelCommission) * 100).toFixed(0),
        // otherChannelExpenses: ((frontOrderForm.otherChannelExpenses) * 100).toFixed(0),
        receivedPrice: ((frontOrderForm.receivedPrice) * 100).toFixed(0),
        salePrice: ((frontOrderForm.salePrice) * 100).toFixed(0),
        channelDiscount: ((frontOrderForm.channelDiscount) * 100).toFixed(0)
      }
      if ( frontOrderForm.discount && frontOrderForm.discount !== 0 ){
        params.discountId = frontOrderForm.discountType;
      }
      console.info('orderParams:', params)
      return API.omsAPI[this.env].clientServer.orderAtFrontDesk(params, Object.assign(this.protHeaders, {'Right': this.token}))
    },
    checkPlaceOrderParams() {
      let isAccess = true;
      let msg = "";
      if (this.selectedRooms.length==0) {
        isAccess = false;
        msg = "请选择房间"
      }
      return { result: isAccess, msg }
    },
    getRoomIds() {
      let roomIds = [];
      for (let i=0; i<this.selectedRooms.length; i++) {
        let roomId = this.selectedRooms[i].roomId;
        roomIds.push(roomId);
      }
      roomIds = new Set(roomIds);
      return Array.from(roomIds).toString();
    },
    resetRoomList() {
      this.roomList = {
        count: 0, //记录总数
        pageCount: 0, //页面总数
        page: 1, // 第几页
        pageSize: 10, // 每页数量
        loading: false,
        data: []
      };
      this.roomList.data = [];
    },
    resetSelectingRoomsModalForm() {
      this.selectingRoomsModalForm = {
        hotel: "",
        roomType: "",
        roomNo: "",
        roomName: ""
      }
    },
    // 选择订单来源
    changeSourceType(currTypeId) {
      for (let i = 0; i < this.sourceType.length; i++) {
        if (this.sourceType[i].id == currTypeId) {
          this.currentSourceData = this.sourceType[i];
          this.priceRelationDetail = this.sourceType[i].priceRelationDetail && JSON.parse(this.sourceType[i].priceRelationDetail) || {}
          this.priceExpression = this.sourceType[i].expression && JSON.parse(this.sourceType[i].expression)
          if (this.selectedRooms.length > 0) this.calculateIn('default')
          this.resetFormFields();
          return;
        }
      }
    },
    // 计算价格
    async calculatePriceAli(params) {
      if (this.protHeaders.Right) delete this.protHeaders['Right']
      let resp = (await API.omsAPI[this.env].clientServer.calculatePriceAli(
        params,
        this.protHeaders
      )).data;
      if (resp.retCode) {
        // 错误警告
        this.$Notice.error({
          title: "获取计算价格数据失败",
          desc: resp.retsmsg
        });
        return
      }
      Object.assign(this.frontOrderForm, resp)
      if (resp.discount === 0) this.frontOrderForm.discountType = ''
    },
    calculateIn (key) {
      this.limitLength(key)  // 限制输入框的字数长度
      clearTimeout(this.delayTimer);
      let params = { 
        sourceId: this.currentSourceData.id 
      }
      if (this.selectedRooms.length > 0) {
        params['orderPrice'] = this.frontOrderForm.totalPrice
      }
      if (key !== 'default') {
        if (this.selectedRooms.length === 0) return;
        for (let i in this.priceExpression) {
          if (this.priceExpression[i].type === 2) {
            params[i] = this.frontOrderForm[i] || 0;
          }
        }
      }
      this.delayTimer = setTimeout(() => {
        this.calculatePriceAli(params)
      }, 1000)
    },
    // 限制输入框number长度限制
    limitLength(key){
      if (this.$refs[key] && this.$refs[key].value.length > 8) {
        this.$refs[key].value = this.$refs[key].value.slice(0, 8) 
        this.frontOrderForm[key] = this.$refs[key].value
      }
    },
    resetFormFields() {
      let fields = Object.assign({}, this.frontOrderForm);
      this.$refs.frontOrderForm.resetFields();
      this.frontOrderForm = fields;
    },
    clearRooms() {
      this.selectedRooms = [];
      this.resetFormFields();
      let initParams = {
        invoicing: false,
        invoicePrice: "",
        totalPrice: '',
        discount: '',
        realPrice: '',
        discountType: 0,
        salePrice: '',
        channelDiscount: '',
        // userPay: 0,
        // otherChannelExpenses: '',
        channelCommission: '',
        receivedPrice: ''
      };
      Object.assign(this.frontOrderForm, initParams);
    },
    clearAllData(){
      Object.assign(this.frontOrderForm, {
        totalPrice: 0,
        phone: "",
        name: "",
        checkDate: [
          Moment().format("YYYY-MM-DD"),
          Moment().add(1, 'days').format("YYYY-MM-DD"),
        ],
        rooms: "",
        invoicing: false,
        remark: "",
        otherNo:'',
        discountType: 0,
      })
      this.clearRooms();
      this.changeSourceType(this.currentSourceData.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.add-distance {
  margin-top: 20px;
}
.inputType{
  width:100%;
  border-radius: 5px;
  border:1px solid #dbdbdb;
  padding: 0 5px;
}
.inputType[disabled]{
  background-color: #ccc;
}
.showOta {
  width: 81.17%;
  height: 32px;
  margin-left: 120px;
  margin-bottom: 24px;
}
.channel-row {
  width: 92%;
  margin: 0 auto 10px;
  font-size: 14px;
  line-height: 44px;
  .col {
    display: flex;
    &:nth-child(odd) {
      margin-right: 42px;
    }
    .txt {
      font-style: normal;
      min-width: 78px;
    }
    span {
      color: #339900;
      font-weight: bold;
      line-height: 25px;
      margin-top: 10px;
      &.red {
        color: #ff0000;
      }
    }
  }
}
</style>






// WEBPACK FOOTER //
// src/pages/order/front-order.vue